import Vue from 'vue';
import VueRouter from 'vue-router';

import { store } from '@/store';

// Routes
import AccountRoutes from './routes/AccountRoutes';
import CompanyRoutes from './routes/CompanyRoutes';
import ErrorRoutes from './routes/ErrorRoutes';
import HomeRoutes from './routes/HomeRoutes';
import IndexRoutes from './routes/IndexRoutes';
import IntegrationRoutes from './routes/IntegrationRoutes';
import OpenRoutes from './routes/OpenRoutes';
import ProjectRoutes from './routes/ProjectRoutes';
import SettingRoutes from './routes/SettingRoutes';

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
        HomeRoutes,
        IndexRoutes,
        AccountRoutes,
        OpenRoutes,
        ProjectRoutes,
        CompanyRoutes,
        SettingRoutes,
        IntegrationRoutes,
        ErrorRoutes,
    ],
});

router.beforeEach(async(to, from, next) => {
    if (!to.matched.length) next();
    for (let route of to.matched) {
        if (route.meta?.middleware) {
            let middlewares = Array.isArray(route.meta.middleware) ? route.meta.middleware : [route.meta.middleware];
            for (let middleware of middlewares) {
                let params = await middleware({ to, from, store });
                if (params) {
                    router.push(params);
                    return next();
                }
            }
        }
    }
    next();
});

router.afterEach((to, from) => {
    document.title = to.meta?.title ? 'CrowdPower | ' + to.meta.title : 'CrowdPower';
    window.cp('page'); // Track pageview.
});

router.onError(error => {
    if (/loading chunk chunk-[a-z0-9]* failed/i.test(error.message)) {
        window.location.reload();
    }
});